module.exports = __webpack_public_path__ + "img/paas.fc55443.svg";